import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from './utils';
import { ResultPreview } from 'src/frontend-common/dto/Interfaces/ILogins';

export const loginSimulatorApi = createApi({
  reducerPath: 'loginSimulatorApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    mode: 'cors',
  }),
  tagTypes: ['Logins'],
  endpoints: (builder) => ({
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    postSimulatorResult: builder.mutation<ResultPreview, { session_id: string; app_key: string }>({
      query: ({ session_id, app_key }) => ({
        url: `v1/logins/simulator/result/${session_id}`,
        method: 'POST',
        body: { app_key },
      }),
      invalidatesTags: ['Logins'],
    }),
  }),
});

export const { usePostSimulatorResultMutation } = loginSimulatorApi;
